// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".user-name-fields[data-v-f9ee931a]{display:grid;grid-template-columns:1fr;grid-column-gap:1em;grid-row-gap:1.5em}@media (min-width:768px){.user-name-fields[data-v-f9ee931a]{grid-template-columns:repeat(2,1fr)}}.form-field[data-v-f9ee931a]:not(:last-of-type){padding-bottom:1.5em}", ""]);
// Exports
module.exports = exports;
